<template>
  <div class="card card-info">
    <div class="card-header">
      <h3 class="card-title">Manage</h3>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <!-- TO DO List -->
          <draggable class="list-group"
                     tag="ul"
                     v-model="list"
                     v-bind="dragOptions"
                     @@start="drag = true"
                     @@end="drag = false">
            <transition-group type="transition" :name="!drag ? 'flip-list' : null">
              <li class="list-group-item"
                  v-for="item in list"
                  :key="item.ID">
                <i :class="item.fixed ? 'fa fa-anchor' : 'glyphicon glyphicon-pushpin'"
                   @@click="item.fixed = !item.fixed"
                   aria-hidden="true"></i>
                {{ item.Name }}
              </li>
            </transition-group>
          </draggable>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <input value="Save" type="button" v-on:click="save()" class="btn btn-success float-right" />
    </div>
  </div>
</template>
 
<script>

  const axios = require('axios').default;
  import draggable from 'vuedraggable'

  export default ({
    components: {
      draggable,
    },

    data() {
      return {
        message: 'Hello Vue!',
        list: [],
        drag: false
      }
    },

    created: function () {
      this.pageLoad();
    },

    methods: {
       
      pageLoad() {
        startReq();
        var vm = this;
        axios.post('/api/RoleApi/pageloadMenuSorting')
          .then(function (response) {
            endReq();
            vm.list = response.data;
          })
      },

      sort() {
        this.list = this.list.sort((a, b) => a.order - b.order);
      },

      save() {
        startReq();
        var vm = this;
        axios.post('/api/RoleApi/saveMenuSorting', {
          lst: vm.list
        })
          .then(function (response) {
            endReq();
            toastr.success('Save Successfully');
            vm.pageload;
          })
      },
    },

    computed: {
      dragOptions() {
        return {
          animation: 200,
          group: "description",
          disabled: false,
          ghostClass: "ghost"
        };
      }
    }
  });


</script>



// WEBPACK FOOTER //
// src/components/core/menuSorting.vue